import React from "react";

const Star = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
      {...props}
    >
      <g clipPath="url(#clip0_84_317)">
        <path
          fill="#FEBF34"
          d="m24.757 8.637-7.314-.678-2.905-6.747a.586.586 0 0 0-1.077 0L10.556 7.96l-7.314.678a.586.586 0 0 0-.333 1.024l5.518 4.848-1.615 7.165a.586.586 0 0 0 .871.633L14 18.557l6.316 3.75a.586.586 0 0 0 .871-.633l-1.615-7.165L25.09 9.66a.586.586 0 0 0-.333-1.024"
        ></path>
        <path
          fill="#FF9C13"
          d="M6.524.98c.372.518 1.425 2.742 2.026 4.038.095.204-.16.388-.324.234C7.188 4.27 5.412 2.566 5.04 2.049A.914.914 0 1 1 6.524.98M21.477.98c-.373.518-1.425 2.742-2.027 4.038-.095.204.161.388.324.234 1.039-.982 2.814-2.686 3.187-3.203A.914.914 0 0 0 21.477.98M27.369 16.167c-.607-.198-3.046-.525-4.463-.704-.223-.028-.32.271-.124.38 1.25.691 3.413 1.865 4.02 2.063a.914.914 0 1 0 .567-1.739M.631 16.167c.607-.198 3.046-.525 4.463-.704.223-.028.32.271.124.38-1.25.691-3.413 1.865-4.02 2.063a.914.914 0 1 1-.567-1.739M13.113 26.486c0-.638.446-3.058.715-4.462.042-.22.357-.22.4 0 .268 1.404.714 3.824.714 4.462a.914.914 0 0 1-1.829 0"
        ></path>
        <path
          fill="#FFC850"
          d="m15.594 3.665-1.056-2.453a.586.586 0 0 0-1.077 0L10.556 7.96l-7.314.678a.586.586 0 0 0-.333 1.024l5.518 4.848-1.615 7.165a.586.586 0 0 0 .871.633l.841-.499c1.378-8.92 5.252-15.469 7.07-18.143"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_84_317">
          <path fill="#fff" d="M0 0h28v28H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default Star;
